module.exports = __webpack_public_path__ + "static/media/b22@2x.2bd9cf5c.png";